(function () {
  'use strict';

  function pauseVideos(slide) {
    if (!slide) return;
    slide.querySelectorAll('video').forEach(function (video) {
      video.pause();
    });
  }

  function playVideos(slide) {
    if (!slide) return;
    slide.querySelectorAll('video').forEach(function (video) {
      var playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function () {});
      }
    });
  }

  function initHeroBanner(root) {
    var section = root.classList.contains('hero-banner') ? root : root.querySelector('.hero-banner');
    if (!section || section.dataset.heroBannerInit === 'true') return;

    var swiperEl = section.querySelector('.hero-banner__swiper');
    if (!swiperEl || typeof Swiper === 'undefined') return;

    var slides = section.querySelectorAll('.swiper-slide');
    if (!slides.length) return;

    section.dataset.heroBannerInit = 'true';

    var autoplayEnabled = section.getAttribute('data-autoplay') === 'true';
    var autoplaySpeed = parseInt(section.getAttribute('data-autoplay-speed'), 10) || 5000;
    var paginationEl = section.querySelector('.hero-banner__pagination');
    var prevEl = section.querySelector('.hero-banner__prev');
    var nextEl = section.querySelector('.hero-banner__next');
    var slideLabel = section.getAttribute('data-slide-label') || 'Slide';

    var config = {
      slidesPerView: 1,
      loop: slides.length > 1,
      speed: 600,
      watchOverflow: true,
      on: {
        init: function (swiper) {
          playVideos(swiper.slides[swiper.activeIndex]);
        },
        slideChangeTransitionStart: function (swiper) {
          swiper.slides.forEach(function (slide) {
            pauseVideos(slide);
          });
        },
        slideChangeTransitionEnd: function (swiper) {
          playVideos(swiper.slides[swiper.activeIndex]);
        }
      }
    };

    if (prevEl && nextEl) {
      config.navigation = {
        prevEl: prevEl,
        nextEl: nextEl
      };
    }

    if (paginationEl) {
      config.pagination = {
        el: paginationEl,
        clickable: true,
        bulletClass: 'hero-banner__dot',
        bulletActiveClass: 'is-active',
        renderBullet: function (index, className) {
          return (
            '<button type="button" class="' +
            className +
            '" aria-label="' +
            slideLabel +
            ' ' +
            (index + 1) +
            '"></button>'
          );
        }
      };
    }

    if (autoplayEnabled && slides.length > 1) {
      config.autoplay = {
        delay: autoplaySpeed,
        disableOnInteraction: false
      };
    }

    new Swiper(swiperEl, config);
  }

  function initAll() {
    document.querySelectorAll('.hero-banner-section .hero-banner, section.hero-banner').forEach(initHeroBanner);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target) {
      initHeroBanner(event.target);
    }
  });
})();
